// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.89.2-next',
  revision: '6ae96f657',
  branch: 'next',
  date: 'Tue, 11 Aug 2026 16:34:47 GMT'
};